import { Directive, ElementRef, Renderer2, AfterViewInit, Optional } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[appDisabledIfConseiller]',
  standalone: false
})
export class DisabledIfConseillerDirective implements AfterViewInit {
  constructor(
    private readonly _appConfig: AppConfigService,
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Optional() matCheckbox: MatCheckbox,
    @Optional() matButton: MatButton,
    @Optional() matInput: MatInput
  ) {
    if (this.isConseiller) {
      [matCheckbox, matButton, matInput].forEach(control => {
        if (control) {
          control.disabled = true;
        }
      });
    }
  }

  ngAfterViewInit() {
    if (this.isConseiller) {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
      this.renderer.setProperty(this.el.nativeElement, 'tabIndex', -1);
      this.renderer.removeAttribute(this.el.nativeElement, 'href');
      this.renderer.removeAttribute(this.el.nativeElement, 'target');
      this.renderer.addClass(this.el.nativeElement, 'read-only-conseiller');
    }
  }

  get isConseiller() {
    return this._appConfig.isConfigLoaded && this._appConfig.configData.conseiller;
  }
}
